import React, { useState } from "react";
import PageTitle from "components/PageTitle/PageTitle";
import { Autocomplete } from "@material-ui/lab";
import {
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Divider,
  CardContent,
  CardHeader,
} from "@material-ui/core";
import { Typography } from "components/Wrappers/Wrappers";

import Field from "components/CustomFields/Field.js";
import SelectField from "components/CustomFields/SelectField.js";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";

import { useHistory } from "react-router-dom";
import routes from "routes";
import logo from "images/logoPagesRS.jpg";
import { verifyEmail } from "utils/emailValidation";
import PasswordCreationFields, {
  isPasswordStrongEnough,
} from "components/CustomFields/PasswordCreationFields";
// styles
import useStyles from "./styles";
import { cleanEmptyKeys } from "utils/cleanEmptyKeys";
import { dbGet, dbPut } from "utils/DBFetchers";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { getRoleName } from "utils/roleNameGetter";

// roles
import { hidedRoles, roleTranslation } from "pages/users/roles/utils";

const blankEditUserForm = {
  id: "",
  username: "",
  email: "",
  name: "",
  lastName: "",
  role: null,
  distributor: "",
  pharmaGroup: "",
  pharmacy: null,
  password: "",
  confirmPassword: "",
  isVisible: null,
  kam: "",
  medic: "",
  consultant: "",
};
const blankAllResults = {
  distributors: [],
  pharmagroups: [],
  pharmacies: [],
  roles: [],
  kams: [],
  medics: [],
  consultants: [],
};

const visibleOptions = [
  { id: 1, name: "Si" },
  { id: 2, name: "No" },
];

export default function EditUserPage(props) {
  var classes = useStyles();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [editUserForm, updateForm] = useState(blankEditUserForm);
  const [allResults, setAllResults] = useState(blankAllResults);
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleChange = (event) => {
    updateForm({ ...editUserForm, [event.target.name]: event.target.value });
  };

  const handleAutoCompleteConsultantChange = (event, newValue) => {
    updateForm({
      ...editUserForm,
      consultant: newValue ? newValue.id : null,
    });
  };
  const handleAutoCompleteMedicChange = (event, newValue) => {
    updateForm({ ...editUserForm, medic: newValue ? newValue.id : null });
  };

  const handleSetCategory = (value, pharmacyId = null) => {
    setSelectedCategory(value);
    var role = allResults.roles.find((x) => x.id === value);
    if (!role) return;
    var roleName =
      role.name === "kam" || role.name === "medic" || role.name === "consultant"
        ? role.name + "s"
        : role.name;
    let endpoint = roleName;
    if (roleName === "pharmacies") {
      endpoint += "/" + pharmacyId;
    }
    if (role && allResults[roleName] && allResults[roleName].length === 0) {
      getResults(endpoint, roleName);
    }
  };

const getResults = (categoryEndpoint, stateKey = categoryEndpoint) => {
    dbGet(categoryEndpoint).then((data) => {
      if (data && !Array.isArray(data) && data.id) {
        data = [data];
      }

      if (!data || !data.length) return;
      
      if (stateKey === "roles" && getRoleName() !== "super_admin") {
        data = data.filter((role) => !hidedRoles.has(role.name));
      }
      if (stateKey === "distributors") {
        data = data.filter((x) => x.works_with_independents && x.id !== 19);
      }
      data = data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        // a must be equal to b
        return 0;
      });
      let mapped = data.map((item) => {
        let name = `${item["name"]}`;
        if (stateKey === "pharmacies") {
          name = `${item["name"]} - ${item["code"]}`;
        } else if (stateKey === "consultants" || stateKey === "medics") {
          name = item["last_name"] ? name + item["last_name"] : name;
          name = item["rut"] ? name + ` | ${item["rut"]}` : name;
        }
        return {
          id: item["id"],
          name: name,
        };
      });
      
      setAllResults(prev => ({ ...prev, [stateKey]: mapped }));
    });
  };

  const getUserInfo = (userId) => {
    dbGet(`users/${userId}`).then((data) => {
      updateForm({
        ...editUserForm,
        id: userId,
        username: data.username,
        email: data.email,
        name: data.name,
        lastName: data.lastname,
        role: data.role?.id,
        isVisible: data.is_visible ? 1 : 2,
        distributor: data.distributor_id ? data.distributor_id : "",
        pharmaGroup: data.pharma_group_id ? data.pharma_group_id : "",
        pharmacy: data.pharmacy_id ? data.pharmacy_id : "",
        kam: data.kam_id ? data.kam_id : "",
        medic: data.medic_id ? data.medic_id : "",
        consultant: data.consultant_id ? data.consultant_id : "",
      });
      handleSetCategory(data.role?.id, data.pharmacy_id);
    });
  };
  const checkFormComplete = () => {
    if (
      !editUserForm.username ||
      !editUserForm.name ||
      !editUserForm.email ||
      !editUserForm.email.includes("@") ||
      !editUserForm.role ||
      !editUserForm.isVisible ||
      (editUserForm.password &&
      (!isPasswordStrongEnough(editUserForm.password) ||
      editUserForm.password !== editUserForm.confirmPassword))||
      (editUserForm.role === 2 && !editUserForm.pharmacy) ||
      (editUserForm.role === 3 && !editUserForm.distributor) ||
      (editUserForm.role === 4 && !editUserForm.pharmaGroup) ||
      (editUserForm.role === 6 && !editUserForm.kam) ||
      (editUserForm.role === 9 && !editUserForm.medic) ||
      (editUserForm.role === 10 && !editUserForm.consultant)
    )
      return false;
    return true;
  };
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!checkFormComplete()) {
      snackbarOpen(
        "error",
        "Hay campos sin completar o incorrectos. Por favor completelos para poder editar el usuario.",
      );
      return;
    }
    if (!editUserForm.name) {
      snackbarOpen(
        "error",
        "Debe ingresar el Nombre del usuario. Por favor completelo para poder editar el usuario.",
      );
      return;
    }
    if (!verifyEmail(editUserForm.email)) {
      snackbarOpen(
        "error",
        "El email ingresado no es válido. Por favor ingrese un email válido para poder editar el usuario.",
      );
      return;
    }

    let completedForm = {
      username: editUserForm.username,
      email: editUserForm.email,
      password: editUserForm.password, // if password empty then db doesnt change
      role_id: editUserForm.role,
      name: editUserForm.name,
      lastname: editUserForm.lastName ? editUserForm.lastName : null,
      pharmacy_id: editUserForm.pharmacy,
      distributor_id: editUserForm.distributor,
      pharma_group_id: editUserForm.pharmaGroup,
      kam_id: editUserForm.kam,
      medic_id: editUserForm.medic,
      consultant_id: editUserForm.consultant,
    };
    completedForm = cleanEmptyKeys(completedForm);
    completedForm["is_visible"] = editUserForm.isVisible === 1 ? true : false;
    completedForm["lastname"] = editUserForm.lastName ? editUserForm.lastName : null;

    setIsLoading(true);
    dbPut(`users/${props.props.location.state.userId}`, completedForm)
      .then((data) => {
        snackbarOpen("success", "Usuario editado exitosamente");
        redirectToUsersPage();
      })
      .catch((error) => {
        snackbarOpen(
          "error",
          error[0]
            ? error[0].description_es
            : "No se pudo editar el usuario. Intente nuevamente.",
        );
        setIsLoading(false);
        return;
      });
  };

  const cancelEditUser = () => {
    updateForm(blankEditUserForm);
    setSelectedCategory("");
    history.goBack();
  };

  const redirectToUsersPage = (user) => {
    setTimeout(() => {
      updateForm(blankEditUserForm);
      setSelectedCategory("");
      setIsLoading(false);
      history.push(routes.usersUsers);
    }, 1500);
  };
  
  const admin_or_superadmin_permission = () => {
    return getRoleName() === "super_admin" || getRoleName() === "admin";
  };

  React.useEffect(() => {
    getResults("roles");
  }, []);

  React.useEffect(() => {
    if (props.props.location.state) {
      getUserInfo(props.props.location.state.userId);
    }
  }, [allResults.roles]);

  const title = `Editar Usuario${editUserForm.username ? ": " : ""}${
    editUserForm.username ? editUserForm.username : ""
  }`;

  return (
    <>
      <div>
        <PageTitle
          title={title}
          // button={
          //   <img src={logo} alt="logo" className={classes.logotypeImage} />
          // }
        />
      </div>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Grid
        style={{ display: "flex", margin: 0 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
      >
        <form autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.text}>
                Datos del usuario
              </Typography>
              <div style={{ marginTop: "4%" }}>
                <Field
                  labelName="Usuario"
                  required={true}
                  id="username"
                  value={editUserForm.username}
                  divClassType={classes.generalPurposeItems}
                  fieldClassType={classes.generalPurposeField}
                  onChange={handleChange}
                  error={!editUserForm.username}
                  disabled={true}
                ></Field>
                <Field
                  labelName="Email *"
                  required={true}
                  id="email"
                  value={editUserForm.email}
                  divClassType={classes.generalPurposeItems}
                  fieldClassType={classes.generalPurposeField}
                  onChange={handleChange}
                  error={!editUserForm.email}
                ></Field>
                <Field
                  labelName="Nombre *"
                  id="name"
                  value={editUserForm.name}
                  divClassType={classes.generalPurposeItems}
                  fieldClassType={classes.generalPurposeField}
                  onChange={handleChange}
                ></Field>
                <Field
                  labelName="Apellido"
                  id="lastName"
                  value={editUserForm.lastName}
                  divClassType={classes.generalPurposeItems}
                  fieldClassType={classes.generalPurposeField}
                  onChange={handleChange}
                ></Field>
                {/* {admin_or_superadmin_permission() && (
                  <> */}
                {/* <div className={classes.generalPurposeItems}>
                  <Typography className={classes.text} weight="bold">
                    Rol *
                  </Typography>
                  <TextField
                    id="role"
                    select
                    disabled={true}
                    className={classes.generalPurposeField}
                    value={selectedCategory ? selectedCategory : ""}
                    error={!selectedCategory}
                    onChange={(e) => {
                      handleSetCategory(e.target.value);
                      updateForm({
                        ...editUserForm,
                        role: e.target.value,
                        distributor: "",
                        pharmaGroup: "",
                        pharmacy: "",
                      });
                    }}
                    // label="Seleccione"
                    variant="outlined"
                    margin="dense"
                  >
                    {allResults.roles.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name in roleTranslation
                          ? roleTranslation[option.name]
                          : option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </div> */}

                <Field
                  labelName="Rol"
                  id="role"
                  value={
                    selectedCategory ? 
                    roleTranslation[allResults.roles.find((x) => x.id === selectedCategory)?.name] : ""
                  }
                  divClassType={classes.generalPurposeItems}
                  fieldClassType={classes.generalPurposeField}
                  disabled={true}
                ></Field>

                {getRoleName() === "super_admin" ? (
                  // <SelectField
                  //   divClassName={classes.generalPurposeItems}
                  //   fieldClassName={classes.generalPurposeField}
                  //   displayText="Es visible"
                  //   id="isVisible"
                  //   // label="Seleccione"
                  //   name="isVisible"
                  //   value={editUserForm.isVisible}
                  //   onChange={handleChange}
                  //   allValues={visibleOptions}
                  // />
                  <Field
                    labelName="Es visible"
                    id="isVisible"
                    value={editUserForm.isVisible ? "Si" : "No"}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}
                {allResults.roles.some(
                  (role) =>
                    role.id === editUserForm.role && role.name === "kam",
                ) ? (
                  // <SelectField
                  //   divClassName={classes.generalPurposeItems}
                  //   fieldClassName={classes.generalPurposeField}
                  //   displayText="KAM"
                  //   id="kam"
                  //   // label="Seleccione"
                  //   name="kam"
                  //   value={editUserForm.kam}
                  //   onChange={handleChange}
                  //   allValues={allResults.kams}
                  // />
                  <Field
                    labelName="KAM"
                    id="kam"
                    value={editUserForm.kam ? allResults.kams.find((x) => x.id === editUserForm.kam)?.name : ""}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}
                {allResults.roles.some(
                  (role) =>
                    role.id === editUserForm.role && role.name === "medic",
                ) ? (
                  // <SelectField
                  //   divClassName={classes.generalPurposeItems}
                  //   fieldClassName={classes.generalPurposeField}
                  //   displayText="Médico"
                  //   id="medic"
                  //   // label="Seleccione"
                  //   name="medic"
                  //   value={editUserForm.medic}
                  //   onChange={handleChange}
                  //   allValues={allResults.medics}
                  // />
                  <Field
                    labelName="Médico"
                    id="medic"
                    value={editUserForm.medic ? allResults.medics.find((x) => x.id === editUserForm.medic)?.name : ""}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}
                {allResults.roles.some(
                  (role) =>
                    role.id === editUserForm.role && role.name === "consultant",
                ) ? (
                  // <SelectField
                  //   divClassName={classes.generalPurposeItems}
                  //   fieldClassName={classes.generalPurposeField}
                  //   displayText="Visitador"
                  //   id="consultant"
                  //   // label="Seleccione"
                  //   name="consultant"
                  //   value={editUserForm.consultant}
                  //   onChange={handleChange}
                  //   allValues={allResults.consultants}
                  // />
                  <Field
                    labelName="Visitador"
                    id="consultant"
                    value={editUserForm.consultant ? allResults.consultants.find((x) => x.id === editUserForm.consultant)?.name : ""}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}
                {/* <SelectField
                  divClassName={classes.generalPurposeItems}
                  fieldClassName={classes.generalPurposeField}
                  disabled={
                    !allResults.roles.some(
                      (role) =>
                        role.id === editUserForm.role &&
                        role.name === "distributors",
                    )
                  }
                  displayText="Distribuidor"
                  id="distributor"
                  // label="Seleccione"
                  name="distributor"
                  value={editUserForm.distributor}
                  onChange={handleChange}
                  allValues={allResults.distributors}
                /> */}
                {allResults.roles.some(
                  (role) =>
                    role.id === editUserForm.role && role.name === "distributors",
                ) ? (
                  <Field
                    labelName="Distribuidor"
                    id="distributor"
                    value={editUserForm.distributor ? allResults.distributors.find((x) => x.id === editUserForm.distributor)?.name : ""}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}

                {/* <SelectField
                  divClassName={classes.generalPurposeItems}
                  fieldClassName={classes.generalPurposeField}
                  disabled={
                    !allResults.roles.some(
                      (role) =>
                        role.id === editUserForm.role &&
                        role.name === "pharmagroups",
                    )
                  }
                  displayText="Grupo"
                  id="pharmaGroup"
                  // label="Seleccione"
                  name="pharmaGroup"
                  value={editUserForm.pharmaGroup}
                  onChange={handleChange}
                  allValues={allResults.pharmagroups}
                /> */}
                {allResults.roles.some(
                  (role) =>
                    role.id === editUserForm.role && role.name === "pharmagroups",
                ) ? (
                  <Field
                    labelName="Grupo"
                    id="pharmaGroup"
                    value={editUserForm.pharmaGroup ? allResults.pharmagroups.find((x) => x.id === editUserForm.pharmaGroup)?.name : ""}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}

                {/* <SelectField
                  divClassName={classes.generalPurposeItems}
                  fieldClassName={classes.generalPurposeField}
                  disabled={
                    !allResults.roles.some(
                      (role) =>
                        role.id === editUserForm.role &&
                        role.name === "pharmacies",
                    )
                  }
                  displayText="Farmacia"
                  id="pharmacy"
                  // label="Seleccione"
                  name="pharmacy"
                  value={editUserForm.pharmacy}
                  onChange={handleChange}
                  allValues={allResults.pharmacies}
                /> */}
                {allResults.roles.some(
                  (role) =>
                    role.id === editUserForm.role && role.name === "pharmacies",
                ) ? (
                  <Field
                    labelName="Farmacia"
                    id="pharmacy"
                    value={editUserForm.pharmacy ? allResults.pharmacies.find((x) => x.id === editUserForm.pharmacy)?.name : ""}
                    divClassType={classes.generalPurposeItems}
                    fieldClassType={classes.generalPurposeField}
                    disabled={true}
                  ></Field>
                ) : (
                  <></>
                )}
                  {/* </>
                )} */}
              </div>
            </Grid>
          </Grid>

          {getRoleName() === "super_admin" && (
            <>
              <Divider style={{ marginTop: "3%" }} />
              <CardHeader title="Contraseña" />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <div className={classes.passwordItems}>
                      {passwordOpen ? (
                        <PasswordCreationFields
                          password={editUserForm.password}
                          confirmation={editUserForm.confirmPassword}
                          onPasswordChange={handleChange}
                          onConfirmationChange={handleChange}
                        />
                      ) : (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => setPasswordOpen(true)}
                        >
                          Modificar contraseña
                        </Button>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
            </>
          )}

          <Grid container spacing={10}>
            <Grid item xs={12}>
              <div className={classes.buttonSpacing}>
                {isLoading ? (
                  <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    Guardar
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={cancelEditUser}
                >
                  Cancelar
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
}
